import { MoneyInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PaymentApplyToInvoiceParams = {
  paymentId: string;
  invoiceId: string;
  appliedAmount: MoneyInput;
};

export const paymentApplyToInvoiceAtom = createMutationAtomFactory(
  'finance.paymentApplyToInvoice',
  (params: PaymentApplyToInvoiceParams) => ({
    financePaymentApplyToInvoice: {
      __args: {
        input: {
          paymentId: params.paymentId,
          invoiceId: params.invoiceId,
          appliedAmount: params.appliedAmount,
        },
      },
      id: true,
      documentNumber: true,
      status: true,
      amount: {
        amount: true,
        currencyCode: true,
      },
      invoices: {
        invoice: {
          id: true,
          documentNumber: true,
        },
        appliedAmount: {
          amount: true,
          currencyCode: true,
        },
        appliedAt: true,
      },
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
